/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DriverBehaviourEventIntervalType,
    DriverBehaviourEventIntervalTypeFromJSON,
    DriverBehaviourEventIntervalTypeFromJSONTyped,
    DriverBehaviourEventIntervalTypeToJSON,
    Position,
    PositionFromJSON,
    PositionFromJSONTyped,
    PositionToJSON,
    Stream,
    StreamFromJSON,
    StreamFromJSONTyped,
    StreamToJSON,
} from './';

/**
 * 
 * @export
 * @interface DriverBehaviourEventInterval
 */
export interface DriverBehaviourEventInterval {
    /**
     * 
     * @type {string}
     * @memberof DriverBehaviourEventInterval
     */
    monitoredObjectId: string;
    /**
     * 
     * @type {number}
     * @memberof DriverBehaviourEventInterval
     */
    clientId: number;
    /**
     * 
     * @type {Position}
     * @memberof DriverBehaviourEventInterval
     */
    positionStart?: Position;
    /**
     * 
     * @type {Position}
     * @memberof DriverBehaviourEventInterval
     */
    positionEnd?: Position;
    /**
     * 
     * @type {Date}
     * @memberof DriverBehaviourEventInterval
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof DriverBehaviourEventInterval
     */
    end?: Date;
    /**
     * 
     * @type {string}
     * @memberof DriverBehaviourEventInterval
     */
    eventId?: string;
    /**
     * 
     * @type {Stream}
     * @memberof DriverBehaviourEventInterval
     */
    stream?: Stream;
    /**
     * 
     * @type {string}
     * @memberof DriverBehaviourEventInterval
     */
    type?: DriverBehaviourEventIntervalTypeEnum;
    /**
     * 
     * @type {DriverBehaviourEventIntervalType}
     * @memberof DriverBehaviourEventInterval
     */
    eventType: DriverBehaviourEventIntervalType;
}

export function DriverBehaviourEventIntervalFromJSON(json: any): DriverBehaviourEventInterval {
    return DriverBehaviourEventIntervalFromJSONTyped(json, false);
}

export function DriverBehaviourEventIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverBehaviourEventInterval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': json['monitored_object_id'],
        'clientId': json['client_id'],
        'positionStart': !exists(json, 'position_start') ? undefined : PositionFromJSON(json['position_start']),
        'positionEnd': !exists(json, 'position_end') ? undefined : PositionFromJSON(json['position_end']),
        'start': (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'eventId': !exists(json, 'event_id') ? undefined : json['event_id'],
        'stream': !exists(json, 'stream') ? undefined : StreamFromJSON(json['stream']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'eventType': DriverBehaviourEventIntervalTypeFromJSON(json['event_type']),
    };
}

export function DriverBehaviourEventIntervalToJSON(value?: DriverBehaviourEventInterval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_id': value.monitoredObjectId,
        'client_id': value.clientId,
        'position_start': PositionToJSON(value.positionStart),
        'position_end': PositionToJSON(value.positionEnd),
        'start': (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'event_id': value.eventId,
        'stream': StreamToJSON(value.stream),
        'type': value.type,
        'event_type': DriverBehaviourEventIntervalTypeToJSON(value.eventType),
    };
}

/**
* @export
* @enum {string}
*/
export enum DriverBehaviourEventIntervalTypeEnum {
    DriverBehaviour = 'driver_behaviour'
}


